import { BrandLogo } from "./BrandLogo";

export const LoadingScreen = ({ fading }) => (
  <div
    data-testid="loading-screen"
    className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-bg transition-opacity duration-500 ${
      fading ? "pointer-events-none opacity-0" : "opacity-100"
    }`}
  >
    <BrandLogo eager className="h-9" />
    <div className="mt-8 h-[3px] w-40 overflow-hidden rounded-full bg-surfaceAlt">
      <div className="loader-line h-full bg-lime" />
    </div>
  </div>
);
